import classNames from "classnames";

import { FieldTypeIcon } from "@/shared/components/ResourceView/Filters/fieldTypeIcons";
import { CustomFieldType } from "@/shared/domain/customFields";

import {
  customFieldTypeIconType,
  customFieldTypeLabel,
} from "./customFieldPresentation";
import styles from "./FieldTypeSelector.module.css";

interface FieldTypeSelectorProps {
  value: CustomFieldType;
  onChange: (value: CustomFieldType) => void;
  options: CustomFieldType[];
}

/**
 * Grid of selectable field-type cells, three per row. Each cell reuses the
 * shared type icon + label so the cue matches the rest of the custom-fields
 * surface; the selected cell is tinted with the brand color.
 */
export function FieldTypeSelector({
  value,
  onChange,
  options,
}: FieldTypeSelectorProps) {
  return (
    <div className={styles.grid} role="radiogroup" aria-label="Field type">
      {options.map((option) => {
        const selected = option === value;
        return (
          <button
            key={option}
            type="button"
            role="radio"
            aria-checked={selected}
            className={classNames(styles.cell, { [styles.selected]: selected })}
            onClick={() => onChange(option)}
          >
            <FieldTypeIcon
              type={customFieldTypeIconType(option)}
              className={styles.icon}
            />
            <span>{customFieldTypeLabel(option)}</span>
          </button>
        );
      })}
    </div>
  );
}
